export function removeQueryPart(fileUrl?: string | null) {
  if (fileUrl) {
    const parts = fileUrl.split('?');
    if (parts.length > 0) {
      return parts[0];
    }
  }
}
